import user from './modules/user'
import location from './modules/location'

export default {
  /** user 工具类 */
  user,

  /** location 工具类 */
  location
}
